import type { LandingMessages } from '../types';

export const es: LandingMessages = {
  brand: 'My Budget',
  navAria: 'Principal',
  signIn: 'Iniciar sesión',
  headline: 'Mantén el gasto bajo control sin anotar cada ticket',
  supporting:
    'Controla gastos, define objetivos claros y ve el progreso en visual — para detectar sobrepasos a tiempo, no a fin de mes.',
  standaloneHeadline: 'Tus presupuestos, listos aquí',
  standaloneSupporting: 'Inicia sesión para abrir My Budget en este dispositivo.',
  startFree: 'Empezar gratis',
  seeHow: 'Ver cómo funciona',
  pricingNote:
    'Gratis para los primeros clientes. Puedes exportar tus datos en cualquier momento.',
  sessionExpired: 'Sesión caducada.',
  problemLabel: 'El problema',
  problemTitle: 'El exceso de gasto se vuelve invisible hasta que acaba el mes',
  problemBody:
    'Sin un plan claro y una vista en vivo de tus límites, las compras pequeñas se acumulan en silencio. Cuando te das cuenta, el mes ya se fue.',
  howLabel: 'Cómo funciona',
  howTitle: 'Planifica, sigue y adelántate',
  howLead:
    'Sin vincular bancos. Define lo importante, pon límites y mira el gasto frente a esos objetivos en una vista calmada.',
  step1Title: 'Define objetivos claros',
  step1Body:
    'Decide para qué es cada presupuesto — mes a mes, un viaje o el hogar compartido — para que cada límite tenga sentido.',
  step2Title: 'Controla el gasto por categoría',
  step2Body:
    'Asigna topes mensuales a comida, ocio y el resto, según cómo vives de verdad.',
  step3Title: 'Detecta sobrepasos a tiempo',
  step3Body:
    'El progreso visual muestra cuándo una categoría se aprieta o se pasa — mientras aún puedes corregir el rumbo.',
  featuresLabel: 'Qué obtienes',
  featuresTitle: 'Claridad para mantener el gasto a raya',
  featureControlTitle: 'Control de gastos',
  featureControlBody:
    'Límites por categoría y totales en vivo te ayudan a no pasarte, sin malabares en una hoja de cálculo.',
  featureOverrunTitle: 'Alertas de sobrepasos',
  featureOverrunBody:
    'Ve cuándo te acercas o cruzas un límite — señales visuales claras, no sorpresas de fin de mes.',
  featureVisualTitle: 'Información visual',
  featureVisualBody:
    'Barras de progreso y vistas de gasto hacen el mes legible de un vistazo, incluso en semanas ajetreadas.',
  featurePlanningTitle: 'Planificación sencilla',
  featurePlanningBody:
    'Organiza el mes antes de empezarlo: presupuestos, categorías y cantidades que sí puedes sostener.',
  featureGoalsTitle: 'Objetivos claros',
  featureGoalsBody:
    'Nombra para qué sirve cada presupuesto y, si lo necesitas, mantén metas personales y compartidas distintas.',
  abstractCategoryA: 'Supermercado',
  abstractCategoryB: 'Comidas fuera',
  abstractUsed: '{percent}% usado',
  abstractNearLimit: 'Casi al límite',
  finalLabel: 'Empieza hoy',
  finalTitle: 'Límites claros. Gasto con calma.',
  finalLead:
    'Planifica el mes, controla a dónde va el dinero y atrapa los sobrepasos a tiempo — con visuales que mantienen los objetivos a la vista.',
  apiKeysLabel: 'Automatización',
  apiKeysTitle: 'Automatiza el registro de tus gastos',
  apiKeysLead:
    'Tras iniciar sesión, configúralo en Ajustes — la guía te muestra cómo conectar Atajos de iOS.',
  apiKeysCta: 'Leer la guía de configuración',
  installLabel: 'En tu teléfono',
  installTitle: 'Añadir a la pantalla de inicio',
  installLead:
    'Abre My Budget como una app — acceso más rápido, pantalla completa sin la barra de Safari, y notificaciones en iOS compatibles.',
  installStep1Title: 'Pulsa Compartir',
  installStep1Body:
    'En Safari, pulsa el botón Compartir en la parte inferior de la pantalla.',
  installStep2Title: 'Añadir a pantalla de inicio',
  installStep2Body:
    'Desplázate en la hoja de compartir y elige Añadir a la pantalla de inicio.',
  installStep3Title: 'Confirma Añadir',
  installStep3Body:
    'Pulsa Añadir arriba a la derecha. My Budget aparece en tu pantalla de inicio.',
  installAndroidNote:
    'En Chrome para Android: menú del navegador → Instalar app o Añadir a la pantalla de inicio.',
  footer: 'My Budget — finanzas personales sin el estrés de las hojas de cálculo.',
  languageAria: 'Idioma',
  langEn: 'EN',
  langEs: 'ES',
  documentTitle: 'My Budget',
};
